import { useBreakpoints } from '@vueuse/core';

export const useDeviceStore = defineStore('deviceStore', () => {
  // SSR: user-agent
  const headers = useRequestHeaders(['user-agent']);
  const userAgent = headers?.['user-agent'] || '';
  const isServerMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());

  // CSR: breakpoints
  const breakpoints = useBreakpoints({ xs: 528 });
  const isClientMobile = breakpoints.smallerOrEqual('xs');

  const isMobile = computed(() => {
    return import.meta.client ? isClientMobile.value : isServerMobile;
  });

  return { isMobile };
});
